import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-md">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-800 font-medium hover:border-primary-400 transition-colors cursor-pointer"
      >
        <span>{t("categories.dropdownLabel")}</span>
        <i className={`ri-arrow-down-s-line text-lg transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>

      {open && (
        <div className="absolute z-30 mt-2 w-full max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 shadow-sm">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors"
            >
              <span>{t(cat.nameKey)}</span>
              <i className="ri-arrow-right-up-line text-foreground-400"></i>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}